import React from 'react';
import { Gift, RefreshCw } from 'lucide-react';
import { useDailyCredits } from '../keno/useDailyCredits';
import { dailyRewardDescription } from '../../content/dailyCredits';
import './quickRewards.css';

export const HeaderDailyCredits = ({ owner }) => {
  const reward = useDailyCredits(owner);
  const clock = [Math.floor(reward.remaining / 3600), Math.floor(reward.remaining / 60) % 60, reward.remaining % 60].map((part) => String(part).padStart(2, '0')).join(':');
  const title = reward.error || reward.data?.blocked_reason || `${dailyRewardDescription(reward.data)}${reward.remaining ? ` · available in ${clock}` : ' · Claim now'}`;
  return <div className="header-daily-control" data-testid="header-daily-control">
    <button type="button" className="header-daily-claim" data-testid="header-daily-claim" title={title} aria-label={title}
      disabled={reward.busy || (!reward.error && !reward.data?.can_claim)} onClick={reward.error ? reward.reload : reward.claim}>
      {reward.error ? <RefreshCw size={17} /> : <Gift size={17} />}<span data-testid="header-daily-label">{reward.busy ? 'Claiming…' : reward.error ? 'Retry' : reward.remaining ? <time data-testid="header-daily-countdown" dateTime={reward.data.next_claim_at}>{clock}</time> : 'Daily V Credits'}</span>
    </button>
    {reward.error && <span className="sr-only" role="alert" data-testid="header-daily-error">{reward.error}</span>}
  </div>;
};